import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import pSifreDegistir from '../../../../api/models/pSifreDegistir';
import pUiVersionKontrol from '../../../../api/models/pUiVersionKontrol';
import rUiVersionKontrolSonuc from '../../../../api/models/rUiVersionKontrolSonuc';

export default ApiBaseReducer<pSifreDegistir, IInputDataStateModel<pUiVersionKontrol, rUiVersionKontrolSonuc>, rUiVersionKontrolSonuc>(
    ActionSubTypes.API_UIVERSIONKONTROL,
    DefaultInputDataStateModel<pUiVersionKontrol, rUiVersionKontrolSonuc>()
);
